export default __webpack_public_path__ + "static/media/syncNews.8383926a.jpg";